var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-component"},[_c('div',{staticClass:"not-found-component__error"},[_vm._v("\n    404\n  ")]),_vm._v(" "),_c('div',{staticClass:"not-found-component__text"},[_vm._v("\n    Not Found\n  ")])])
}]

export { render, staticRenderFns }